import { render, staticRenderFns } from "./talent.vue?vue&type=template&id=71f287b4"
import script from "./talent.vue?vue&type=script&lang=js"
export * from "./talent.vue?vue&type=script&lang=js"
import style0 from "./talent.vue?vue&type=style&index=0&id=71f287b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports